import React, { useEffect, useState } from 'react';
import { Form, Input, Row, Col, Modal, message } from 'antd';
import { useTranslation } from 'react-i18next';

// Import React FilePond
import { FilePond, registerPlugin } from 'react-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'

// Import the Image EXIF Orientation and Image Preview plugins
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

const AddRoomModal = (props) => {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const [files, setFiles] = useState([])
  const { t } = useTranslation();

  const onFinish = (values) => {
    console.log('Received values:', values);
    if (props.uploadImg == null) {
      message.warning(t('rooms.PleaseUploadRoomImage'));
      return;
    }
    props.action(values)
    props.close()
  };

  useEffect(() => {
    if (files.length > 0) {
      files.forEach(fileItem => {
        props.upload(fileItem.file)
      })
    }
  }, [files])

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error(t('rooms.OnlyJpgPngAllowed'));
    }
    return isJpgOrPng;
  };

  return (
    <Modal
      title={t('rooms.addRoom')}
      open={props.visible}
      onOk={() => form.submit()}
      onCancel={props.close}
    >
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
      >
        <Row gutter={16}>
          <Col span={24} lg={12}>
            <Form.Item
              label={t('rooms.roomName')}
              name="roomname"
              rules={[{ required: true, message: t('rooms.enterRoomName') }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24} lg={12}>
            <Form.Item
              label={t('rooms.roomLocation')}
              name="roomlocation"
              rules={[{ required: true, message: t('rooms.enterRoomLocation') }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24} lg={12}>
            <Form.Item
              label={t('rooms.roomLength')}
              name="length"
              rules={[{ required: true, message: t('rooms.enterRoomLength') }]}
            >
              <Input type='number'/>
            </Form.Item>
          </Col>
          <Col span={24} lg={12}>
            <Form.Item
              label={t('rooms.roomWidth')}
              name="width"
              rules={[{ required: true, message: t('rooms.enterRoomWidth') }]}
            >
              <Input type='number'/>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={t('rooms.description')}
              name="description"
            >
              <TextArea />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label={t('rooms.uploadRoomImage')}
              name="image"
            >
              <FilePond
                files={files}
                onupdatefiles={setFiles}
                allowMultiple={false}
                maxFiles={1}
                name="files"
                labelIdle={t('rooms.filepondLabel')}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddRoomModal;
